import React from 'react'
import { BasicFeature } from '@scentregroup/shared/hub-components/basic-feature'
import getDescriptiveLocation from '@scentregroup/shared/helpers/get-descriptive-location'
import { TradingHourDay } from '@scentregroup/shared/graphql'
import { ContentDetail } from '../../../lib/get-content-detail'
import { SGPageTemplateWithAdZones } from '@scentregroup/shared/types/page-templates'
import { Centre } from '../../../lib/get-centre-by-slug'
import { createRetailerUtilityfromStore } from '../../../lib/createRetailerUtilityfromStore'
import { Template } from '@scentregroup/shared/components/page-templates/template'

export function StoryContentDetail({
  centre,
  template,
  content,
  tradingHours,
}: {
  template?: SGPageTemplateWithAdZones
  content: ContentDetail['story']
  centre?: Centre
  tradingHours?: TradingHourDay[]
}): JSX.Element {
  const { title, bodyCopy: body } = content
  const supportingColor = content?.heroImageSet?.masterSupportingColour
  const heroImage = content?.heroImageSet?.master?.url
  const store = content?.storesCollection?.featuredStoreForCentre

  const retailerUtility = createRetailerUtilityfromStore(
    store,
    tradingHours,
    centre?.timeZone,
    centre?.slug
  )
  const location = getDescriptiveLocation({
    physicalAddress: store?.physicalAddress || '',
    storeTitle: store?.title || '',
  })

  return (
    <>
      <BasicFeature
        title={title}
        body={body}
        location={location}
        supportingColor={supportingColor}
        heroImage={heroImage}
        timeZone={centre?.timeZone}
        retailerUtility={retailerUtility}
      />
      {template && <Template template={template} />}
    </>
  )
}
